import f3tch from 'f3tch';

// Constants
import API_URL from '../../../api/constants/url.constant.api';

// Profiles
import profile from '../../../api/profiles/multipart.profile.api';

/**
 * Upload an XLSX price list file to the backend
 * @param {File} file - The XLSX file to upload
 */
const uploadPricelistApi = (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return f3tch('/tyres/upload/pricing')
    .profile(profile({ url: API_URL() }))
    .body(formData)
    .post();
};

export default uploadPricelistApi;
